module.exports = __webpack_public_path__ + "img/568.c5938f4a.gif";